import { render, staticRenderFns } from "./CustomerDashBookings.vue?vue&type=template&id=3d591156&scoped=true"
import script from "./CustomerDashBookings.vue?vue&type=script&lang=js"
export * from "./CustomerDashBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d591156",
  null
  
)

export default component.exports